import React from "react";
import { Header, Text } from ".";
import { env } from "src/utils/env";

const DownloadApps = () => {
  return (
    <React.Fragment>
      <div className="download-apps">
        <div className="download-apps__container">
          <div className="download-apps__greeting">
            <Header
              fontFamily={["Roboto", "Lexend"]}
              fontWeight={["700", "700"]}
              fontSize={["24px", "40px"]}
              lineHeight={["28px", "52px"]}
              letterSpacing={["-0.24px", "0.005em"]}
              color={["#FFFFFF", "#FFFFFF"]}
            >
              Beli Gadget & Lainnya
              <br />
              Jadi Lebih Hemat
            </Header>
            <Text
              fontFamily={["Lexend", "Lexend"]}
              fontWeight={["700", "700"]}
              fontSize={["18px", "18px"]}
              lineHeight={["24px", "24px"]}
              letterSpacing={["0.005em", "0.005em"]}
              color={["#FFFFFF", "#FFFFFF"]}
            >
              Download My Home Credit sekarang.
            </Text>
          </div>
          <div className="download-apps__downloads">
            {/* This Link goes to Home Credit || Goole Play or App Store (Haven't installed the app yet) */}
            <a href="https://hcid.onelink.me/By7i/6fxuutsc" target="_blank">
              <img
                src={`${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/adbc5753-4bad-47fc-8e13-a4d485f2f4de/google-play.png`}
                alt="Google Play"
              />
            </a>
            {/* This Link goes to Home Credit || Goole Play or App Store (Haven't installed the app yet) */}
            <a href="https://hcid.onelink.me/By7i/6fxuutsc" target="_blank">
              <img
                src={`${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/05f18130-0c00-48fa-b7cd-edf8af2fe63b/app-store.png`}
                alt="App Store"
              />
            </a>
          </div>
        </div>
        <div className="download-apps__background" />
      </div>
      <style jsx scoped>{`
        .download-apps {
          position: relative;
          background: #ca172c;
          height: 420px;
        }

        .download-apps__container {
          z-index: 1;
          position: relative;
          box-sizing: border-box;
          max-width: 1064px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 16px 16px 0;
        }

        .download-apps__background {
          width: 100%;
          height: 195.5px;
          position: relative;
          max-width: 1440px;
          display: flex;
          background-image: url("${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/e847a711-29fb-46e4-8d96-7878da2b5f83/cash-loan-download-apps.png");
          background-position: center 100%;
          background-repeat: no-repeat;
          background-size: auto 192px;

          left: unset;
          transform: unset;
        }

        .download-apps__greeting {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding: 16px;
        }

        .download-apps__downloads {
          display: flex;
          flex-direction: row;
          gap: 6px;
          margin-left: 16px;
          margin-top: 8px;
        }

        .download-apps__downloads img {
          width: 138px;
          height: 40px;
        }

        @media only screen and (min-width: 480px) {
          .download-apps {
            height: 318px;
          }

          .download-apps__container {
            box-sizing: border-box;
            max-width: 1064px;
            margin: 0 auto;
            display: flex;
            height: 100%;
            flex-direction: column;
            padding: 16px;
          }

          .download-apps__background {
            position: absolute;
            max-width: 1440px;
            display: flex;
            height: 100%;
            background-image: url("${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/e847a711-29fb-46e4-8d96-7878da2b5f83/cash-loan-download-apps.png");
            background-position: right 100%;
            background-repeat: no-repeat;
            background-size: auto 100%;

            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }

          .download-apps__downloads {
            display: flex;
            flex-direction: row;
            gap: 16px;
            margin-left: 8px;
            margin-top: 6px;
          }

          .download-apps__container {
            padding: 40px 0;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default DownloadApps;
